import React from 'react'
import * as Displays from '@morningtrain/react-displays'
import { Translation } from '@morningtrain/react-translations'
import * as UI from 'ui'
import { Link } from '@morningtrain/react-displays'

export function FileCard ({ onClick }) {
  return (
    <div
      onClick={onClick}
      className='order-card bg-gray-200 h-20 rounded-lg text-center flex flex-col items-center justify-between overflow-hidden'
    >
      <Link name='url' className='w-full'>
        <UI.SpaceBetween className='w-full px-6'>
          <UI.Text weight='medium' size='xl' className='py-6 '>
            <Displays.Text
              name='name'
              label={<Translation name='tags.name' />}
            />
          </UI.Text>
          <UI.Icons.Download className='w-6 h-6' />
        </UI.SpaceBetween>
      </Link>
    </div>
  )
}
